import {lazy} from "react";

import Home from './pages/home';
import GoodsList from "./pages/goodsList";
import GoodsDetail from "./pages/goodsDetail";
import ConfirmOrder from "./pages/confirmOrder";
import Cart from "./pages/cart";
import My from "./pages/my";
import BookingList from "./pages/bookingList";
import BookingDetail from "./pages/bookingDetail";
import SearchGoodsPage from './pages/searchGoodsPage';
import Login from './pages/login';
import Register from './pages/register';
import MyBooking from './pages/my/myBooking';
import MyCoupon from './pages/my/myCoupon';
import OrderDetail from './pages/my/orderDetail';
import OrderList from './pages/my/orderList';
import MessageCenter from './pages/messageCenter';
import ShippingAddress from './pages/my/shippingAddress';
import News from './pages/news';
import MyIntegral from './pages/my/myIntegral';
import BookingOrderDetail from './pages/my/bookingOrderDetail';
import ForgetPwd from './pages/forgetPwd';
import Agreement from "./pages/agreement";
import OrderQRCode from "./pages/my/orderQRCode";
import WishList from "./pages/wishList";
import OrderComment from "./pages/my/orderComment";
import Callus from "./pages/callus";
// import WithTracker from "../../publicComponent/WithTracker";

const authPages = [
  // '/cart',
  // '/my',
  '/confirmOrder',
  '/orderList',
  '/orderDetail',
  '/myCoupon',
  '/bookinglist',
  '/myIntegral',
  '/myBooking',
  '/shippingAddress',
];

const routes = [
  {
    path: '/',
    name: '首页',
    element: <Home/>
  },
  {
    path: '/goodsList',
    name: '所有商品',
    element: <GoodsList/>
  },
  {
    path: '/goodsDetail',
    name: '商品详情',
    element: <GoodsDetail/>
  },
  {
    path: '/cart',
    name: '购物车',
    element: <Cart/>
  },
  {
    path: '/my',
    name: '我的',
    element: <My></My>
  },
  {
    path: '/confirmOrder',
    name: '确认订单',
    element: <ConfirmOrder/>
  },
  {
    path: '/orderList',
    name: '订单列表',
    element: <OrderList/>
  },
  {
    path: '/orderDetail',
    name: '订单详情',
    element: <OrderDetail/>
  },
  {
    path: '/myCoupon',
    name: '我的优惠券',
    element: <MyCoupon/>
  },
  {
    path: '/bookingList',
    name: '预约列表',
    element: <BookingList/>
  },
  {
    path: '/bookingDetail',
    name: '预约详情',
    element: <BookingDetail/>
  },
  {
    path: '/bookingOrderDetail',
    name: '预约详情',
    element: <BookingOrderDetail/>
  },
  {
    path: '/messageCenter',
    name: '消息中心',
    element: <MessageCenter/>
  },
  {
    path: '/myIntegral',
    name: '我的积分',
    element: <MyIntegral/>
  },
  {
    path: '/myBooking',
    name: '我的预约',
    element: <MyBooking/>
  },
  {
    path: '/shippingAddress',
    name: '收货地址',
    element: <ShippingAddress/>
  },
  {
    path: '/login',
    name: '登录',
    element: <Login/>
  },
  {
    path: '/register',
    name: '注册',
    element: <Register/>
  },
  {
    path: '/forgetPwd',
    name: '忘记密码',
    element: <ForgetPwd/>
  },
  {
    path: '/news',
    name: '资讯分享',
    element: <News/>
  },
  {
    path: '/searchGoodsPage',
    name: '搜索商品',
    element: <SearchGoodsPage/>
  },
  {
    path: '/agreement',
    name: '隐私条款与注册协议',
    element: <Agreement/>
  },
  {
    path: '/orderQRCode',
    name: '核销码',
    element: <OrderQRCode/>
  },
  {
    path: '/wishList',
    name: '心愿单',
    element: <WishList/>
  },
  {
    path: '/orderComment',
    name: '订单评价',
    element: <OrderComment/>
  },
  {
    path: '/callus',
    name: '联系我们',
    element: <Callus/>
  },
];
export {authPages};
export default routes;
